var applicationSettings = {
    serverAddress:'sta-worker01.ettesal.net', // Can be overridden with a host name or ip

    defaultDialOutProtocol: 'sip', // sip | h323 | mssip | rtmp | auto

    languages: {
        'English (US)': 'configuration/languages/en-us.json',
		'Persian (FA)': 'configuration/languages/fa-ir.json',
        // 'Norsk (Bokmål)': 'configuration/languages/no-nb.json' // Example additional language (make sure the language file exist)
    },

    bandwidths: [{
        name: 'IDS_BANDWIDTH_LOW',
        value: 192 + 64
    }, {
        name: 'IDS_BANDWIDTH_MEDIUM',
        value: 512 + 64
    }, {
        name: 'IDS_BANDWIDTH_HIGH',
        value: 1200 + 64
    }, {
        name: 'IDS_BANDWIDTH_MAXIMUM',
        value: 2400 + 64
    }],

    defaultDialOutRole: 'host', // 'host' or 'guest'

    enableFullMotionPresentation: true,
		 // Uncomment to enable the use of H264
	h264Enabled: true,

    // Uncomment the following line to hide registration settings from the desktop client UI
    // desktopClientHideRegistrationSettings: true,

    // Uncomment the following line to hide connection settings from the desktop client UI
    // desktopClientHideConnectionSettings: true,

    // Uncomment the next line and specify an img path to override conference-avatar:
    // overrideConferenceAvatar: 'configuration/themes/default/conference-avatar.jpg',

	plugins: [

    //    {
    //         name: "چیدمان اتاق",
    //         template: "configuration/plugins/layout.html"
    //     },
    //     {
    //         name: "چیدمان اتاق (نسخه۲)",
    //         template: "configuration/plugins/layout2.html"
    //     },
    //     {
    //         name: "چیدمان اتاق (ترکیبی)",
    //         template: "configuration/plugins/layout3.html"
    //     },
        {
            name: "چینش اتاق",
            template: "configuration/plugins/layout-pin.html"
            // this is needs for final confirm
        },
    //    {
    //         name: "حالت انتظار",
    //         template: "configuration/plugins/holdresume.html"
    //     },
    ],

    
};

    // Uncomment to use PNG for presentation (higher quality but uses more bandwidth)
    // enablePNGPresentation: true,

    // Uncomment one of the next lines to specify a client-side TURN server to use
    // turnServer: { url: 'turn:turn.example.com', username: 'user', credential: 'pass' },
    // turnServer: { url: 'turn:turn.example.com:443?transport=tcp', username: 'user', credential: 'pass' },

    // Uncomment and reconfigure the next line if you use a customized screensharing extension
    // screenshareApi: 'cakeGetScreen',

    // controlGatewayCalls: true, // Uncomment this line to show the conference-control menu in GW calls


//Default configuration to apply to first-time users
var defaultUserSettings = {
    language: 'configuration/languages/fa-ir.json',

    defaultBandwidth: 512 + 64, // Make sure the value is in applicationSettings.bandwiths

    promptDisconnect: true,
    promptMedia: true,
    analyticsReportingEnabled: true,
    fullMotionPresentationByDefault: true,
    muteOnJoin: false,
    startMinimized: false,
    sideBarHidden: false,
    sideBarHiddenInGW: false,
};

angular.module('cakeapp').config(function($sceDelegateProvider) { $sceDelegateProvider.resourceUrlWhitelist([ 'self', 'https://vc.videocake.ir/**' ]); });

if (window.chrome && !window.chrome.webstore) {
     window.chrome.webstore = true;
}










